import React, { useState, useEffect } from 'react';
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonLoading, IonToast, IonButton } from '@ionic/react';
import { 
  Box, 
  Card, 
  CardContent, 
  Typography, 
  Button, 
  CircularProgress,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Alert,
  IconButton,
  Tooltip,
  Stack,
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from '@mui/material';
import { Visibility, CheckCircle, Pending, Warning, Inventory } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { baseUrl, config, requestID } from '../../../common/utils';
import axios from 'axios';
import { useQuery } from 'react-query';
import { deleteRequestOrder } from '../../../api/stock-transfer/stock-transfer';
 
const StatusChip = styled(Chip)(({ theme }) => ({
  fontWeight: 500,
  '&.pending': {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.dark,
  },
  '&.completed': {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.dark,
  },
  '&.partial': {
    backgroundColor: theme.palette.info.light,
    color: theme.palette.info.dark,
  },
}));

const StyledCard = styled(Card)(({ theme }) => ({
  margin: theme.spacing(2),
  padding: theme.spacing(3),
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: theme.shadows[3],
}));

interface RequestItem {
  id: string;
  product_id: string;
  product_name: string;
  quantity: number;
  available: number;
  transferred?: number;
}

interface TransferRequest {
  id: string;
  requested_by: string;
  items: RequestItem[];
  status: 'pending' | 'completed' | 'partial';
  date: string;
  notes?: string;
}

const ViewStewardStock: React.FC = () => {
  const [requests, setRequests] = useState<TransferRequest[]>([]);
  const [loading, setLoading] = useState(false);
    const [stewardStock, setStewardStock] = useState([]);
    const [stewardData, setStewardData] = useState([]);
    const [stockCount, setStockCount] = useState('');

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [transferDialogOpen, setTransferDialogOpen] = useState(false);
  const [currentRequest, setCurrentRequest] = useState<TransferRequest | null>(null);
  const [transferQuantities, setTransferQuantities] = useState<Record<string, number>>({});
  const [selectedStaff, setSelectedStaff] = useState("");

const [filteredStock, setFilteredStock] = useState([]);
const [searchTerm, setSearchTerm] = useState("");
const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(10);
 const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedRequestId, setSelectedRequestId] = useState(null);

  useEffect(() => {
   // fetchPendingRequests();
  }, []);
 
  const getBarStaff = async () => {
    const payload = { requestID: requestID, config };
    const response = await axios.post(
      `${baseUrl()}settings/getBarStaff`,
      payload,
      config
    );
    console.log('stffs',{ response });

    return response.data.data;
  };


  const {
    data,
    isLoading,
    error: isError,
  } = useQuery("fetchStaffs", getBarStaff);

  
  const zeroStewardStock = async (selectedStaffx: string) => {
    console.log("Zeroing stock for:", selectedStaffx);
    const payload = {
      requestID: requestID,
      user_id: selectedStaffx || ""
    };
    try {
      const response = await axios.post(
        `${baseUrl()}warehouses/zeroStewardStock`,
        payload,
        config
      );
      console.log('Zero Stock Response:', response.data);
      setToastMessage(`Stock for ${selectedStaffx } has been zeroed.`);
      setShowToast(true);
      setFilteredStock([]); // Clear the filtered stock after zeroing
      setSelectedStaff(""); // Reset selected staff
    } catch (error) {
      console.error('Error zeroing stock:', error);
      setToastMessage("Failed to zero stock");
      setShowToast(true);
    }
  };  


  // const getStewardInventoryAlld = async () => {
  //   const payload = { requestID: requestID, 
  //     user_id: selectedStaff || ""
  //    };
  //   const response = await axios.post(
  //     `${baseUrl()}warehouses/getStewardInventoryAll`,
  //     payload,
  //     config
  //   );  
  //   console.log( response.data.data );

  //   setStewardData(response.data.data);
  // //  setStockCount(response.data.totalStockCount || '0');
  //   //return response.data.data;
  // };
const getStewardInventoryAll = async () => {
  const payload = {
    requestID, // no selectedStaff needed
  };

  const response = await axios.post(
    `${baseUrl()}warehouses/getStewardInventoryAll`,
    payload,
    config
  );

  return response.data; // expected to contain: { data: [...], totalStockCount: number }
};

 
const {
  data: stewardInventory,
  isLoading: isLoadingInventory,
  error: errorInventory,
  refetch, // <- this is the function you'll call
} = useQuery(["getStewardInventoryAll"], getStewardInventoryAll);


 

useEffect(() => {
  if (stewardInventory?.data) {
    const filtered = stewardInventory.data.filter(item => Number(item.qty) > 0);
    setStewardData(filtered);
    setStockCount(stewardInventory.totalStockCount || 0);
  }
}, [stewardInventory]);


  // const getStewardInventoryBy_user_id = async (selectedStaff) => {
  //   const payload = { requestID: requestID, 
  //     user_id: selectedStaff || ""
  //    };
  //   const response = await axios.post(
  //     `${baseUrl()}warehouses/getStewardInventoryBy_user_id`,
  //     payload,
  //     config
  //   );  
  //   console.log('stffs',{ response });

  //   setStewardStock(response.data.data);
  //   setStockCount(response.data.totalStockCount || '0');
  //   //return response.data.data;
  // };
  
useEffect(() => {
 
    getStewardInventoryAll();
  
}, []);


const handleViewStock = () => {
  const filtered = stewardData.filter(
    item => item.user_id === selectedStaff  || selectedStaff === ""
  );
 setFilteredStock(filtered);
 // setFilteredStock(stewardData);
  setToastMessage(`Viewing stock for ${selectedStaff || 'All Staff'}`);
  setShowToast(true);
  console.log('Filtered Stock:', filtered);
  console.log('Selected Staff:', selectedStaff);
};


 
 
 
    const handleCancel = async (selectedStaffx: string) => {
    //setLoading(true);
    console.log("Cancelling request:", selectedStaffx);
    setFilteredStock([]);

    zeroStewardStock(selectedStaffx);

      setConfirmOpen(false); // Close the confirmation dialog

  };
    //   const deleteRequest = async (request_id) => {
    //   const data = {
    //     request_id: request_id,
    //     //   requestID: requestID(),
    //   };
  
    //   setLoading(true);
  
    //   try {
    //     const response = await deleteRequestOrder(data);
    //     console.log("Delete response:", response);
    //     // setProducts(response.data);
    //     //console.log('Fetched products:', response.totalStockCount);
    //     //setStockCount(response.totalStockCount);
    //     //setProducts(response.totalStockCount);

    //         setToastMessage("Zero Stock successfully");
    // setShowToast(true);
    //   } catch (error) {
    //     console.log(error);
    //     setToastMessage("Failed delete");
    //     setShowToast(true);
    //   } finally {
    //     setLoading(false);
    //   }
    // };


  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Bar-Steward Requisition Balance </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <StyledCard>
          <CardContent>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
              <Typography variant="h5" component="h2">
                Steward Requisition Balance 
              </Typography>

        
<FormControl size="small" sx={{ minWidth: 160 }}>
                <InputLabel>Staff</InputLabel>
                <Select
                  label="Staff"
                  value={selectedStaff}
                  onChange={(e) => {setSelectedStaff(e.target.value)//, 
                    //getStewardInventoryBy_user_id(e.target.value)

                  }}
                >
                  <MenuItem value="">All Staff</MenuItem>
                  {data?.map((staff,I) => (
                    <MenuItem key={staff.user_id} value={staff.user_id}>
                      {staff.firstName  + " " + staff.lastName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Button 
                variant="outlined" 
                startIcon={<Inventory />}
                  onClick={handleViewStock}

               // onClick={fetchPendingRequests}
                disabled={loading}
              >
                View Stock
              </Button>

     {/*          <Button 
  variant="outlined" 
  onClick={() => refetch()}
>
  Refresh Inventory
</Button> */}
            </Box>
            
              <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
                     <DialogTitle>Confirm Cancellation</DialogTitle>
                     <DialogContent>
Are you sure you want to reset this steward's stock to zero?
                     </DialogContent>
                     <DialogActions>
                       <Button onClick={() => setConfirmOpen(false)} color="inherit">
                         No
                       </Button>
                       <Button
                         onClick={() => {
                           handleCancel(selectedStaff);
                           setConfirmOpen(false);
                         }}
                         color="error"
                       >
                         Yes, Cancel
                       </Button>
                     </DialogActions>
                   </Dialog>
<TableContainer component={Paper} sx={{ mt: 2 }}>
  <Table>
    <TableHead>
      <TableRow>
        <TableCell><strong>Product</strong></TableCell>
        <TableCell><strong>Category</strong></TableCell>
        <TableCell><strong>Price</strong></TableCell>
        <TableCell><strong>Quantity</strong></TableCell>
       </TableRow>
    </TableHead>
    <TableBody>
      {filteredStock.length > 0 ? (
        <>
          {filteredStock.map((item) => (
            <TableRow key={item.product_id}>
              <TableCell>{item.name}</TableCell>
              <TableCell>{item.category_name}</TableCell>
              <TableCell>₦{parseFloat(item.price).toFixed(2)}</TableCell>
              <TableCell>{item.qty}</TableCell>
             </TableRow>
          ))}

          {/* Summary Row */}
          <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
            <TableCell colSpan={3} align="right" sx={{ fontWeight: 'bold' }}>
              Total Quantity:
            </TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>
              {filteredStock.reduce((acc, item) => acc + Number(item.qty || 0), 0)}
            </TableCell>
            <TableCell />
          </TableRow>


                    <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
            <TableCell colSpan={3} align="right" sx={{ fontWeight: 'bold' }}>
                  { selectedStaff && selectedStaff !='All Staff' && (
             
              <Chip
                                       label="Zero Stock"
                                       size="small"
                                       color="success"
                                       icon={<CheckCircle />}
                                       onClick={() => {
                            setSelectedRequestId(selectedStaff);
                                         setConfirmOpen(true);
                                       }}
                                       sx={{ mr: 2 }}
                                     />
                                  )
                                 }
            </TableCell>
          
        </TableRow>
        </>
      ) : (
        <TableRow>
          <TableCell colSpan={5} align="center">
            No stock found for this user.
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  </Table>
</TableContainer>

          </CardContent>
        </StyledCard>

        {/* Transfer Dialog */}
     

        <IonLoading isOpen={loading} message={'Processing...'} />
        <IonToast
          isOpen={showToast}
          onDidDismiss={() => setShowToast(false)}
          message={toastMessage}
          duration={2000}
        />
      </IonContent>
    </IonPage>
  );
};

export default ViewStewardStock;